import axios from "axios";
import { Toast } from "../../util/Toast";
import {
  CLOSE_BROADCAST_BANNER_DIALOG,
  CREATE_NEW_BROADCAST_BANNER,
  DELETE_BROADCAST_BANNER,
  EDIT_BROADCAST_BANNER,
  GET_BROADCAST_BANNER,
  BROADCAST_BANNER_VIP_SWITCH,
} from "./types";
import { apiInstanceFetch } from "../../util/api";

export const getBroadcastBanner = (bannerType) => (dispatch) => {
  apiInstanceFetch
  .get(`brodcastbanner/retrieveBanners?bannerType=${bannerType}`)
  .then((res) => {
      if (res.status) {
        dispatch({ type: GET_BROADCAST_BANNER, payload: res.data });
      } else {
        Toast("error", res.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const handleBroadcastBannerVIPSwitch = (bannerId) => (dispatch) => {
  axios
    .put(`brodcastbanner/updateBannerStatus?bannerId=${bannerId}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: BROADCAST_BANNER_VIP_SWITCH, payload: res.data.data });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
export const createNewBroadcastBanner = (data) => (dispatch) => {
  axios
    .post(`brodcastbanner/uploadBanner`, data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Banner created successfully!");
        dispatch({ type: CLOSE_BROADCAST_BANNER_DIALOG });
        dispatch({ type: CREATE_NEW_BROADCAST_BANNER, payload: res.data.data });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
export const editBroadcastBanner = (bannerId, data) => (dispatch) => {
  axios
    .patch(`brodcastbanner/updateBanner`, data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Banner updated successfully!");
        dispatch({ type: CLOSE_BROADCAST_BANNER_DIALOG });
        dispatch({
          type: EDIT_BROADCAST_BANNER,
          payload: { data: res.data.data, id: bannerId },
        });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
export const deleteBroadcastBanner = (bannerId) => (dispatch) => {
  axios
    .delete(`brodcastbanner/discardBanner?bannerId=${bannerId}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: DELETE_BROADCAST_BANNER, payload: bannerId });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};
